import { logError } from '@/src/utils/logError'

export const ClevertapIos = {
    event(name: string, payload: Object) {
        try {
            const filterPayload = JSON.parse(JSON.stringify(payload))
            const message = {
                action: 'recordEventWithProps',
                event: name,
                properties: filterPayload
            }
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ClevertapInterface) {
                window.webkit.messageHandlers.ClevertapInterface.postMessage(message)
            }
        } catch (e) {
            logError('ClevertapIos', e)
        }
    }
}
